import * as React from "react";
import { createContext, PropsWithChildren, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "~/Services/Request";
import { Options } from "~/Types/Options";
import { isAuthenticated } from "~/Services/Authentication";

const CurrentUserContext = createContext<UserProfileViewModel | null>(null);

export const useCurrentUserContext = () => {
    return useContext(CurrentUserContext);
};

export const CurrentUserProvider = (props: PropsWithChildren) => {
    const { data } = useQuery({
        queryKey: ["admin/account/getuserdata"],
        queryFn: () => {
            return get<{ userProfile: UserProfileViewModel }>("/admin/account/getuserdata");
        },
        select: data => data.userProfile,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        enabled: isAuthenticated(),
    });

    if (!isAuthenticated()) {
        return <>{props.children}</>;
    }

    if (!data) {
        return null;
    }

    return <CurrentUserContext.Provider value={data}>{props.children}</CurrentUserContext.Provider>;
};

export interface UserProfileViewModel {
    id: string;
    userName: string;
    roles: string[];
    email: string;
    firstName: string;
    lastName: string;
    position: string;
    company: string;
    phone: string;
    extension: string;
    fax: string;
    languageId: string;
    timeZone: string;
    passwordChangedOn: string;
    lastLoginOn: string;
    activationStatus: string;
    defaultAdminConsoleLanguageCode: string;
}
